<template>
  <div>
    <div id="tracker">
      <div class="step-tracker">
        <div class="step-name">
          <div @click.prevent="goBack()" class="back">
            <img src="../assets/back.png" alt="back icon">
          </div>
          <span class="title-2">{{$route.params.cat}}</span>
        </div>
        <div id="zoom-tracker" class="col-tracker">
          <div class="item-tracker" v-for="(row, i) in list" :key="i">
            <modal :verbatim="row.positiveVerbatim.length > 0 || row.negativeVerbatim.length > 0" :i="row.i" :number="row.index" :step="$route.params.cat" :index="i" :text="row.name"></modal>
            <div class="item-name">
              <span>
                {{row.shortName}}
              </span>
            </div>
            <div @mouseover="openModal($event, $route.params.cat, i, row)" @mouseleave="hideBG()" class="tracker-row">
              <div class="index">
                <span>
                  {{row.index}}
                </span>
              </div>
              <div class="content">
                <div class="top" :class="comparative ? 'margin-right' : ''">
                  <div v-if="row.comparativePositiveIntensity != undefined" class="top-comparative">
                    <div :style="getHeight(row.comparativePositiveIntensity)" class="score">
                      <div class="score-value">
                        <div>
                          {{displayScore(row.comparativePositiveIntensity)}}
                        </div>
                      </div>
                    </div>
                    <div v-if="row.comparativeAverage > 0" :style="getHeight(row.comparativeAverage)" class="score-moyen">
                      <img src="../assets/moyen.png" alt="">
                    </div>
                  </div>
                  <div :style="getHeight(row.positiveIntensity)" class="score">
                    <div class="signal" v-if="row.upperSignalType" v-tooltip.bottom="$t(row.upperSignalType)">
                      <img v-if="row.upperSignalType == 'strength'" src="../assets/strength.png" alt="">
                      <img v-if="row.upperSignalType == 'priority'" src="../assets/priority.png" alt="">
                      <img v-if="row.upperSignalType == 'goodPractice'" src="../assets/goodPractice.png" alt="">
                      <img v-if="row.upperSignalType == 'weakness'" src="../assets/weakness.png" alt="">
                    </div>
                    <div class="score-value">
                      <div>
                        {{displayScore(row.positiveIntensity)}}
                      </div>
                    </div>
                  </div>
                  <div v-if="row.average > 0" :style="getHeight(row.average)" class="score-moyen">
                    <img src="../assets/moyen.png" alt="">
                  </div>
                </div>
                <div class="bottom" :class="comparative ? 'margin-right' : ''">
                  <div v-if="row.comparativeNegativeIntensity != undefined" class="bottom-comparative">
                    <div :style="getHeight(row.comparativeNegativeIntensity)" class="score">
                      <div class="score-value">
                        <div>
                          {{displayScore(row.comparativeNegativeIntensity)}}
                        </div>
                      </div>
                    </div>
                    <div v-if="row.comparativeAverage < 0" :style="getHeight(row.comparativeAverage)" class="score-moyen">
                      <img src="../assets/moyen.png" alt="score moyen">
                    </div>
                  </div>
                  <div :style="getHeight(row.negativeIntensity)" class="score">
                    <div class="signal" v-if="row.lowerSignalType" v-tooltip.bottom="$t(row.lowerSignalType)">
                      <img v-if="row.lowerSignalType == 'strength'" src="../assets/strength.png" alt="">
                      <img v-if="row.lowerSignalType == 'priority'" src="../assets/priority.png" alt="">
                      <img v-if="row.lowerSignalType == 'goodPractice'" src="../assets/goodPractice.png" alt="">
                      <img v-if="row.lowerSignalType == 'weakness'" src="../assets/weakness.png" alt="">
                    </div>
                    <div class="score-value">
                      <div>
                        {{displayScore(row.negativeIntensity)}}
                      </div>
                    </div>

                  </div>
                  <div v-if="row.average < 0" :style="getHeight(row.average)" class="score-moyen">
                    <img src="../assets/moyen.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div @mouseover="openModal($event, $route.params.cat, i, row)" @mouseleave="hideBG()" class="occurrence">
              <div class="occurrence-w" :style="occurrenceStyle(row.occurence)">
                <span>
                  {{row.occurence}} %
                </span>
              </div>
            </div>
            <div v-if="comparative" class="occurrence-comparative">
              <variation :val="row.comparativeOccurenceVariation"></variation>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Variation from "@/components/Variation";
export default {
  components: {
    Variation
  },
  props: {
    list: {
      type: Array,
      default: null
    },
    max: {
      type: Number,
      default: 0
    },
    comparative: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.push("/");
    },
    sanitize(name) {
      return name.replace(/[^a-z0-9]/g, function(s) {
        var c = s.charCodeAt(0);
        if (c == 32) return "-";
        if (c >= 65 && c <= 90) return "_" + s.toLowerCase();
        return "__" + ("000" + c.toString(16)).slice(-4);
      });
    },
    getHeight(value) {
      if (value == 0) {
        return {
          height: 0
        };
      }
      let percentage = (Math.abs(value) / this.max) * 70 + "%";
      let height = `calc(${percentage})`;
      return {
        height: height
      };
    },
    listenWheel() {
      document.getElementById("tracker").addEventListener("wheel", e => {
        if (e.type != "wheel") {
          return;
        }
        let delta = (e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1;
        delta = delta - 100;

        if (e.deltaY < 0) {
          document.getElementById("tracker").scrollLeft += delta;
        }
        if (e.deltaY > 0) {
          document.getElementById("tracker").scrollLeft -= delta;
        }
        e.preventDefault();
      });
    },
    displayScore(value) {
      if (value == 0) return "";
      return value > 0 ? "+" + value : value;
    },
    occurrenceStyle(value) {
      let x = parseInt(value);
      let size = 0;
      let bg = "#fff";
      let color = "#444";
      let font = "0px";
      if (x <= 2) {
        size = 35;
        bg = "#eef8fa";
        color = "#444";
        font = "12px";
      } else if (x > 2 && x <= 5) {
        size = 60;
        bg = "#b2e1e8";
        color = "#444";
        font = "15px";
      } else if (x > 5 && x <= 20) {
        size = 70;
        bg = "#13b5cb";
        color = "#fff";
        font = "18px";
      } else if (x > 20 && x <= 30) {
        size = 80;
        bg = "#0d8aaf";
        color = "#fff";
        font = "23px";
      } else {
        size = 95;
        bg = "#0f5e89";
        color = "#fff";
        font = "28px";
      }
      size = size + "px";
      return {
        width: size,
        height: size,
        backgroundColor: bg,
        color: color,
        fontSize: font
      };
    },
    centerViewOn(e) {
      var x = e.currentTarget.parentNode.offsetLeft;
      document.getElementById("tracker").scrollLeft = x - window.innerWidth / 2;
    },
    openModal(event, step, index, row) {
      let tracker = document.getElementById("tracker");
      tracker.classList.add("active");
      event.currentTarget.parentNode.classList.add("is-active");

      var items = document.getElementsByClassName("item-tracker");
      Array.prototype.forEach.call(items, el => {
        el.classList.remove("is-active");
      });

      let id = this.sanitize(step + "-" + index);
      var els = document.getElementsByClassName("modal");

      Array.prototype.forEach.call(els, el => {
        el.classList.remove("active");
      });

      document.getElementById(id).classList.toggle("active");
      let windowWidth = window.innerWidth;
      let elementPosition = event.currentTarget.parentNode.getBoundingClientRect()
        .left;
      if (elementPosition > windowWidth / 2) {
        document.getElementById(id).classList.add("left");
        document.getElementById(id).classList.remove("right");
      } else {
        document.getElementById(id).classList.remove("left");
        document.getElementById(id).classList.add("right");
      }
    },
    hideBG() {
      document.getElementById("tracker").classList.remove("active");
    }
  },
  computed: {
    formattedList() {
      if (this.list) {
        let res = {};
        for (let i = 0; i < this.list.length; i++) {
          let cat = this.list[i].stage;
          if (res[cat] === undefined) {
            res[cat] = [];
          }
          this.list[i].i = i;
          res[cat].push(this.list[i]);
        }
        return res;
      }
      return [];
    },
    id() {
      return 1
    }
  },
  mounted() {
    this.listenWheel();
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
$radius: 15px;
$itemSize: 100px;
$drawbarSize: 17%;
$drawbarMax: 30px;
#tracker {
  &.active {
    &::after {
      //content: "";
      position: fixed;
      left: 0px;
      right: 0px;
      bottom: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  display: flex;
  flex-direction: row;
  align-items: end;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  min-height: 500px;
  .step-tracker {
    height: 100%;
    display: flex;
    flex-direction: row;
    width: 100%;
    .step-name {
      text-align: center;
      position: relative;
      background-color: #fff;
      border-bottom: 1px solid #edefed;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.25);
      .back {
        background-color: $blue;
        border-radius: 50%;
        overflow: hidden;
        padding: 12px;
        margin-top: 1em;
        cursor: pointer;
        transition: background-color 0.2s;
        &:hover {
          background-color: $blue-D;
        }
        img {
          width: 20px;
        }
      }
      span {
        flex: 1;
        display: block;
        padding: 2em 2em;
        font-weight: bold;
        text-transform: uppercase;
        white-space: nowrap;
        writing-mode: vertical-rl;
        text-orientation: mixed;
        transform: rotate(180deg);
      }
    }
  }
  .col-tracker {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: end;
    width: auto;
    flex: 1;
    background-size: 100px 41px;
    background-image: linear-gradient(to right, #f7f7f7 1px, transparent 1px),
      linear-gradient(to bottom, #f7f7f7 1px, transparent 1px);
    padding: 0;
    .item-tracker {
      display: flex;
      align-items: center;
      position: relative;
      flex-direction: column;
      padding: 0;
      margin: 0;
      height: 100%;
      width: $itemSize;
      width: 190px;
      .item-name {
        padding: 20px 10px;
        height: 170px;
        //background-color: #fff;
        display: flex;
        align-items: flex-end;
        span {
          transform: rotate(-30deg) translateY(-50px) translateX(50px);
          display: block;
          font-weight: bold;
          font-size: 0.85rem;
        }
      }
      .tracker-row {
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        width: 100%;
        margin: auto;
        .index {
          margin: auto;
          text-align: center;
          span {
            border: 1px solid #31b0c1;
            color: #31b0c1;
            border-radius: 33px;
            width: 40px;
            margin: auto;
            font-weight: bold;
            display: block;
            padding: 5px 0;
            font-size: 80%;
            margin-top: 7px;
          }
        }
        .content {
          position: relative;
          height: 100%;
          cursor: pointer;
          &::before {
            content: "";
            position: absolute;
            height: 100%;
            width: 2px;
            left: 0;
            right: 0;
            margin: auto;
            background-color: transparent;
            z-index: -1;
          }
          .top,
          .bottom {
            position: relative;
            height: 50%;
            display: flex;
            overflow: hidden;
            .score {
              transition: width 0.4s;
            }
            &.margin-right {
              > .score {
                margin-right: 50px;
              }
              .score-moyen {
                left: inherit;
                right: 50px;
                z-index: 33333;
              }
            }
          }
          .top {
            align-items: flex-end;
            border-bottom: 1px solid #656565;
            .score {
              background-color: $plus;
              border-top-left-radius: $radius;
              border-top-right-radius: $radius;
              .score-value {
                top: -25px;
              }
            }
          }
          .bottom {
            align-items: inherit;
            .score {
              border-bottom-left-radius: $radius;
              border-bottom-right-radius: $radius;
              background-color: $minus;
              .score-value {
                bottom: -25px;
              }
            }
          }
          .score {
            width: $drawbarSize;
            max-width: $drawbarMax;
            margin: 0 auto;
            cursor: pointer;
            position: relative;
            min-height: 0 !important;
            transform: scale(1);

            transition: transform 0.4s;
            .score-value {
              position: absolute;
              margin: auto;
              left: -50%;
              right: -50%;
              font-size: 12px;
              text-align: center;
              color: $text;
              font-weight: bold;
            }
          }
        }
      }
      .occurrence {
        display: block;
        width: 100%;
        text-align: center;
        margin-top: 1em;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        .occurrence-w {
          margin: auto;
          overflow: hidden;
          background-color: #21aabd;
          color: #222;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.4s;
        }
        span {
        }
      }
    }
  }
}

.signal {
  overflow: hidden;
  margin-bottom: 10px;
  position: absolute;
  top: -55px;
  border: none;
  z-index: 3333;
  left: 0;
  right: 0;
  width: 75%;
  margin: auto;
  img {
    width: 100%;
    height: auto;
    max-width: 20px;
    overflow: hidden;
  }
}

.bottom {
  .signal {
    top: inherit;
    bottom: -55px;
  }
}

#tracker .step-tracker:nth-child(2n) .col-tracker {
  background-color: #fff;
}
#tracker .step-tracker:nth-child(2n + 1) .col-tracker {
  background-color: #fff;
}
#tracker .col-tracker .item-tracker .tracker-row .content .score-moyen {
  width: $drawbarSize;
  max-width: $drawbarMax;
  margin: 0 auto;
  cursor: pointer;
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  z-index: 333;
  min-height: 30px;
  img {
    width: 85%;
    height: auto;
    display: block;
    margin: auto;
    min-width: 17px;
  }
}

#tracker .col-tracker .item-tracker .tracker-row .content .top .score-moyen {
  bottom: 0;
  align-items: flex-start;
}
#tracker .col-tracker .item-tracker .tracker-row .content .bottom .score-moyen {
  top: 0;
  align-items: flex-end;
}

#tracker .col-tracker .item-tracker .tracker-row .content .top-comparative {
  position: absolute;
  z-index: 333;
  opacity: 0.5;
  height: 100%;
  width: auto;
  left: 0;
  right: 0;
  align-items: flex-end;
  display: flex;
  .score {
    margin: 0;
    margin-left: 8px;
    min-height: 5px;
  }
}
#tracker .col-tracker .item-tracker .tracker-row .content .bottom-comparative {
  position: absolute;
  z-index: 333;
  opacity: 0.5;
  height: 100%;
  width: auto;
  left: 0;
  right: 0;
  align-items: flex-start;
  display: flex;
  .score {
    margin: 0;
    margin-left: 8px;
    min-height: 5px;
  }
}

#tracker .col-tracker .item-tracker .tracker-row .content .bottom-comparative {
  .score-moyen {
    //display: none;
    margin: auto;
    margin-left: 50px;
  }
  .score {
    margin-left: 50px;
  }
}
#tracker .col-tracker .item-tracker .tracker-row .content .top-comparative {
  .score-moyen {
    //display: none;
    margin: auto;
    margin-left: 50px;
  }
  .score {
    margin-left: 50px;
  }
}

#tracker .col-tracker .item-tracker {
  &:hover,
  &.is-active {
    z-index: 333333;
    background-color: #fff;
    .occurrence .occurrence-w {
      transform: scale(1.19);
    }
    .content {
      .score {
        transform: scale(1.09);
      }
    }
  }
}
.occurrence-comparative {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
}
</style>